import * as React from 'react'
import './Banner.scss'
import {Link} from 'gatsby-plugin-react-i18next'
import joinClassNames from '../../../helpers/joinClassNames'
import * as ReactMarkdown from 'react-markdown'
import {BannerType} from '../../../hooks/useLayoutBanner'

type Props = {
    banner: BannerType
}

const Banner = ({banner}: Props) => {
    return (
        <Link to={banner.path}>
            <div className={'layout__banner'}>
                <div className={joinClassNames('container', 'layout__banner-container')}>
                    <ReactMarkdown escapeHtml={false}>{banner.content}</ReactMarkdown>
                </div>
            </div>
        </Link>
    )
}

export default Banner
